(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["orivan-editorial"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('orivan-gallery'))customElements.define('orivan-gallery',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;this.addEventListener('click',e=>{const button=e.target.closest('[data-gallery-select]');if(!button)return;this.querySelectorAll('[data-gallery-panel]').forEach(p=>p.hidden=p.dataset.galleryPanel!==button.dataset.gallerySelect);this.querySelectorAll('[data-gallery-select]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));});}});
if(!customElements.get('orivan-tabs'))customElements.define('orivan-tabs',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const list=this.querySelector('.ov-tablist'),buttons=[...this.querySelectorAll('[data-tab]')],panels=[...this.querySelectorAll('[data-panel]')],uid=this.closest('[id]').id;list.setAttribute('role','tablist');list.setAttribute('aria-label',list.dataset.tabsLabel);buttons.forEach((b,i)=>{b.setAttribute('role','tab');b.id=uid+'-tab-'+i;b.setAttribute('aria-controls',uid+'-panel-'+i);panels[i].id=uid+'-panel-'+i;panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',b.id);panels[i].tabIndex=0;});const show=i=>{buttons.forEach((b,n)=>{b.setAttribute('aria-selected',String(i===n));b.tabIndex=i===n?0:-1;panels[n].hidden=n!==i;});};buttons.forEach((b,i)=>{b.addEventListener('click',()=>show(i));b.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%buttons.length;else if(e.key==='ArrowLeft')n=(i+buttons.length-1)%buttons.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=buttons.length-1;else return;e.preventDefault();show(n);buttons[n].focus();});});show(0);}});
if(!customElements.get('orivan-ticker'))customElements.define('orivan-ticker',class extends HTMLElement{connectedCallback(){if(this.ready)return;this.ready=true;const b=this.querySelector('button');b.addEventListener('click',()=>{const paused=this.classList.toggle('is-paused');b.setAttribute('aria-pressed',String(paused));b.setAttribute('aria-label',paused?'Play benefits ticker':'Pause benefits ticker');b.textContent=paused?'Play':'Pause';});}});

  } catch(e) { console.error(e); }
})();
})();
